import { Container } from "@mui/material";
import React from "react";
import {
  PendingApprovalMain,
  PendingImg,
  PendingText,
} from "../../../components/customer/auth/styles/ProfilePasswordChangeStyle";
import Successmark from "../../../assets/images/Successmark.png";

const WalletCreatedPage = () => {
  return (
    <>
      <Container maxWidth="lg">
        <PendingApprovalMain>
          <PendingImg>
            <img src={Successmark} alt="Successmark" />
          </PendingImg>
          <PendingText>
            <h6>Wallet Created!</h6>
            <p>Stripe will verify you bank wallet shortly.</p>
          </PendingText>
        </PendingApprovalMain>
      </Container>
    </>
  );
};

export default WalletCreatedPage;
